import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import { useDispatch } from 'react-redux';
import { getAllProject } from '../../../Redux/Apis/projectApi';
import ErrorText from '../Error/errorText';

const ProjectSelect = ({
    value,
    onChange,
    isDisabled = false,
    placeholder = "Select Project",
    errorMessage = "Please select a project.",
    showError = false,
    showLabel = true,
    className = "",
    isClearable = true,
}) => {
    const dispatch = useDispatch();
    const [projects, setProjects] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        fetchProjects();
    }, []);

    const fetchProjects = async () => {
        try {
            setLoading(true);
            const response = await dispatch(getAllProject());
            if (response.payload && response.payload.data) {
                const projectOptions = response.payload.data.map(project => ({
                    value: project.projectId,
                    label: project.projectName
                }));
                setProjects(projectOptions);
            }
        } catch (error) {
            console.error('Error fetching projects:', error);
        } finally {
            setLoading(false);
        }
    };

    const customStyles = {
        control: (base) => ({
            ...base,
            minHeight: '44px',
            borderRadius: '0.375rem',
            border: '1.5px solid #e5e7eb',
            boxShadow: 'none',
            backgroundColor: '#ffffff',
            '&:hover': {
                border: '1.5px solid var(--color-primary)',
            },
        }),
        menuPortal: (base) => ({ ...base, zIndex: 4000 }),
        menu: (base) => ({ ...base, backgroundColor: '#ffffff', zIndex: 4000 }),
        menuList: (base) => ({ ...base, backgroundColor: '#ffffff' }),
        option: (base, state) => ({
            ...base,
            backgroundColor: state.isSelected ? '#6366f1' : state.isFocused ? '#eef2ff' : '#ffffff',
            color: state.isSelected ? '#ffffff' : '#111827',
        }),
        singleValue: (base) => ({ ...base, color: '#111827' }),
        placeholder: (base) => ({
            ...base,
            color: '#9CA3AF',
        }),
    };

    return (
        <div className={className}>
            {showLabel && <div className='form-label'>Project</div>}
            <Select
                value={value}
                onChange={onChange}
                options={projects}
                placeholder={placeholder}
                isLoading={loading}
                isClearable={isClearable}
                styles={customStyles}
                className={`react-select-container ${className}`}

                classNamePrefix="react-select"
                menuPortalTarget={typeof document !== "undefined" ? document.body : null}
                menuPosition="fixed"
                isDisabled={isDisabled}
            />
            <ErrorText
                message={errorMessage}
                show={showError}
            />
        </div>
    );
};

export default ProjectSelect; 